export { default } from './DetailsSection';
